import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createBlock(_component_el_descriptions, null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "before"),
      _createVNode(_component_el_descriptions_item, { label: "订单税率：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.detail.orderTaxRate) + "%", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { label: "单价(未税)：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.priceWithoutRate(_ctx.detail.orderFee, _ctx.detail.amount, true, _ctx.detail.orderTaxRate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { label: "单价(含税)：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$currency(_ctx.detail.orderFee)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { label: "总价(未税)：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.totalPriceWithoutRate(_ctx.detail.orderFee, _ctx.detail.amount, true, _ctx.detail.orderTaxRate)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions_item, { label: "总价(含税)：" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.numberTimes(_ctx.detail.orderFee, _ctx.detail.amount, true)), 1)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "after")
    ]),
    _: 3
  }))
}